<div *ngIf="isAtLeastAdmin" class="flex mb-4">
	<div class="right">
		<app-toggle-input
			[currentValue]="adminMode"
			label="Admin Mode"
			i18n-label="Admin Mode Label@@contentSectionContainerAdminModeLabel"
			(valueChange)="adminMode = $event"
		></app-toggle-input>
	</div>
</div>

<app-content-section-list
	[contentSections]="contentSections$ | async"
	[enableNewCreativePackageRequests]="enableNewCreativePackageRequests"
	[adminMode]="adminMode"
	[contextState]="contextState"
	(openDialog)="openDialog($event)"
	(delete)="delete($event)"
	(customEvent)="customEvent.emit($event)"
	(updateOrder)="handleUpdateOrder($event)"
	(selectedListing)="selectedListing.emit($event)"
	(selectedPartialListing)="selectedPartialListing.emit($event)"
></app-content-section-list>
